import React, { Fragment } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { connect } from 'react-redux'
import NProgress from 'nprogress'
import { Helmet } from 'react-helmet'
import store from 'store'

// import Loader from 'components/cleanui/layout/Loader'
import PublicLayout from './Public'
import AuthLayout from './Auth'
import MainLayout from './Main'
import EmptyLayout from './Empty'

const Layouts = {
  public: PublicLayout,
  auth: AuthLayout,
  main: MainLayout,
  empty: EmptyLayout,
  provisioning: PublicLayout,
}

// let previousPath = ''
let previousPathname = ''

const publicList = [
  // '/provisioning',
  // '/provisioning/settings',
  // '/provisioning/deleteDomain'
]

const mapStateToProps = ({ user }) => ({
  loading: user.loading,
  // provisioning: user.provisioning,
  authorized: user.authorized,
})

const Layout = ({ loading, authorized, children }) => {
  const location = useLocation();

  // NProgress & ScrollTop Management
  // const { pathname, search } = location;
  const { pathname } = location

  // const currentPath = pathname + search
  if (previousPathname !== pathname) {
    window.scrollTo(0, 0)
    NProgress.start()
  }
  setTimeout(() => {
    NProgress.done()
    // previousPath = currentPath;
    previousPathname = pathname
  }, 300)

  // Layout Rendering
  let needAuth = true;
  const getLayout = () => {
    if (pathname === '/') {
      return 'public'
    }
    if (publicList.indexOf(pathname) > -1) {
      needAuth = false;
      return 'public'
    }
    if (
      pathname.indexOf('/downloadFile') === 0
    ) {
      return 'empty'
    }
    if (
      pathname.indexOf('/redirect') === 0
    ) {
      needAuth = false;
      return 'empty'
    }
    if (/^\/auth(?=\/|$)/i.test(pathname)) {
      needAuth = false;
      return 'auth'
    }
    if (/^\/provisioning(?=\/|$)/i.test(pathname)) {
      needAuth = false;
      return 'provisioning'
    }
    return 'main'
  }

  const layout = getLayout();
  const Container = Layouts[layout]
  const isUserAuthorized = authorized
  const isUserLoading = loading
  const isUserProvisioning = (store.get('app.user.provisioning') === true)
  const isPublic = layout === 'public' || layout === 'provisioning'
  const isProvisioningLayout = layout === 'provisioning'
  const isAuthLayout = layout === 'auth'

  const BootstrappedLayout = () => {
    // show loader when user in check authorization process, not authorized yet and not on login pages
    if (isPublic !== true) {
      if (isUserLoading && !isAuthLayout) {
        return null
      }
      // redirect to login page if current is not login page and user not authorized
      if (needAuth && !isAuthLayout && !isUserAuthorized) {
        console.log(' auth - ', pathname, needAuth, isAuthLayout, isUserAuthorized);
        return <Navigate to="/auth/login" />
      }
    }

    if (isUserProvisioning === true && isProvisioningLayout !== true && isAuthLayout !== true) {
      return <Navigate to="/provisioning" />
    }

    // in other case render previously set layout
    return <Container>{children}</Container>
  }

  return (
    <Fragment>
      <Helmet titleTemplate="Admin Console | %s" title="Admin Console" />
      {BootstrappedLayout()}
    </Fragment>
  )
}

export default connect(mapStateToProps)(Layout)
